import { Box, Tab, Tabs } from '@mui/material';
import { Suspense, useState } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import { workspaceFor } from '../navigation/workspaces';
import WorkspaceErrorBoundary from '../components/WorkspaceErrorBoundary';

const DashboardLayout = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { pathname } = useLocation();
  const space = workspaceFor(pathname);
  const active =
    space.tabs.find(
      ([path]) => pathname === path || pathname.startsWith(path + '/')
    )?.[0] || space.path;
  return (
    <Box display="flex" minHeight="100vh">
      <Sidebar mobileOpen={mobileOpen} onClose={() => setMobileOpen(false)} />
      <Box flex={1} minWidth={0} display="flex" flexDirection="column">
        <Topbar onMenu={() => setMobileOpen(true)} />
        {space.tabs.length > 1 && (
          <Tabs
            value={active}
            variant="scrollable"
            scrollButtons="auto"
            aria-label={`Rubriques ${space.label}`}
            sx={{
              px: { xs: 1, md: 4 },
              background: '#FCFDFB',
              borderBottom: '1px solid',
              borderColor: 'divider',
              minHeight: 50
            }}
          >
            {space.tabs.map(([path, label]) => (
              <Tab
                key={path}
                component={Link}
                to={path}
                value={path}
                label={label}
                sx={{ minHeight: 50, fontSize: 12, minWidth: 0, mr: 2 }}
              />
            ))}
          </Tabs>
        )}
        <Box
          component="main"
          flex={1}
          sx={{
            p: { xs: 2, md: 4 },
            maxWidth: 1600,
            width: '100%',
            mx: 'auto'
          }}
        >
          <WorkspaceErrorBoundary key={pathname}>
            <Suspense
              fallback={
                <Box role="status" sx={{ p: 4, color: 'text.secondary' }}>
                  Chargement de l’espace…
                </Box>
              }
            >
              <Outlet />
            </Suspense>
          </WorkspaceErrorBoundary>
        </Box>
      </Box>
    </Box>
  );
};

export default DashboardLayout;
